var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"containerFloating"},[(_vm.detail)?_c('OutBoundDetail',{attrs:{"dataComponent":_vm.detailData,"campaingsId":_vm.detailData.id}}):_c('OutboundPage')],1)}
var staticRenderFns = []

export { render, staticRenderFns }